import authenticationService from "./AuthenticationService";

class UserService {

  getUserData() {
    let user = authenticationService.retrieveUserDataFromLocalStorage();
    if (user) {
      return user;
    } else {
      return null;
    }
  }

  getUserType() {
    let user = this.getUserData();
    if (user) {
      return user.userType;
    } else {
      return null;
    }
  }

  getUserClients() {
    let user = this.getUserData();
    if (user) {
      return user.relatedClients;
    } else {
      return null;
    }
  }

  getCurrentUserClient() {
    let user = this.getUserData();
    if (user) {
      return {
        clientID: user.clientId,
        type: user.userType,
        name: user.clientName,
      };
    } else {
      return null;
    }
  }

  getClientName() {
    let user = this.getUserData();

    let clientName = user.clientName || this.getClientNameFromRelated() || null;

    return clientName;
  }

  getClientId() {
    let user = this.getUserData();
    if (user && user.clientId) {
      return user.clientId;
    } else {
      return null;
    }
  }

  getClientNameFromRelated() {
    let relatedClients = this.getUserClients();
    let currentClientId = this.getClientId();

    if (relatedClients && Object.keys(relatedClients).length > 0) {
      for (const clientIndex in relatedClients) {
        if (Object.hasOwnProperty.call(relatedClients, clientIndex)) {
          const client = relatedClients[clientIndex];
          if (client.code == currentClientId) {
            return client.name;
          }
        }
      }
    }
    return null;
  }

  getUserToken() {
    let user = authenticationService.retrieveUserDataFromLocalStorage();
    if (user && user.token) {
      return user.token;
    } else {
      return null;
    }
  }

  checkForMyPardiniSession(){
    let user = authenticationService.retrieveUserDataFromLocalStorage();
    if (user && user.myPardiniSession) {
      return true;
    } else {
      return null;
    }
  }
}

export default new UserService();
